var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "can-cancel": false,
              "is-full-page": true
            },
            on: {
              "update:active": function($event) {
                _vm.isLoading = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "8", "offset-lg": "2" } },
                [
                  _c("system-details", {
                    attrs: { system: _vm.system, type: "config", compact: true }
                  }),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("div", { attrs: { id: "system-footer" } }, [
                      _c("h6", [_vm._v(_vm._s(_vm.$t("titles.footer")))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form",
                            [
                              _c("i", [
                                _vm._v(_vm._s(_vm.$t("titles.country")) + ":")
                              ]),
                              _vm._v(" "),
                              _c("v-select", {
                                staticClass: "pb-3 style-chooser",
                                staticStyle: { content: "none" },
                                attrs: {
                                  id: "",
                                  options: _vm.countries,
                                  disabled: _vm.countrySelectDisabled
                                },
                                on: { input: _vm.countryChange },
                                model: {
                                  value: _vm.country,
                                  callback: function($$v) {
                                    _vm.country = $$v
                                  },
                                  expression: "country"
                                }
                              }),
                              _vm._v(" "),
                              _vm.system.PreviousConfiguration
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      on: {
                                        input: function($event) {
                                          return _vm.countryChange()
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      },
                                      model: {
                                        value: _vm.usePreviousConfiguration,
                                        callback: function($$v) {
                                          _vm.usePreviousConfiguration = $$v
                                        },
                                        expression: "usePreviousConfiguration"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("buttons.usePreviousConfig")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    _vm._l(_vm.errorMessages, function(error) {
                      return _c(
                        "b-alert",
                        {
                          key: error.Message,
                          attrs: {
                            show: "",
                            dismissible: "",
                            variant: "danger"
                          }
                        },
                        [_vm._v(_vm._s(error.Message))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "min-width-button",
                              attrs: {
                                type: "button",
                                variant: "outline-secondary",
                                "active-class": "",
                                to: {
                                  name: "system-config-overview",
                                  params: { logosid: this.system.LogosID }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("buttons.back")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "min-width-button",
                              attrs: {
                                type: "button",
                                variant: "outline-secondary",
                                "active-class": "",
                                disabled: _vm.continueDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confirmIfPreviousConfigurationExits()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("buttons.continue")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "min-width-button",
                              staticStyle: { float: "right" },
                              attrs: {
                                type: "button",
                                "align-self": "end",
                                variant: "outline-secondary",
                                "active-class": "",
                                to: {
                                  name: "issue-advanced-system-config",
                                  params: { logosid: this.system.LogosID },
                                  query: { country: this.country }
                                },
                                disabled: _vm.continueDisabled
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t("buttons.advancedConfiguration")
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("previous-configuration-exists-modal", {
        ref: "previousConfigurtionExists",
        on: {
          accept: function($event) {
            return _vm.generateLicense()
          }
        }
      }),
      _vm._v(" "),
      _c("send-config-by-mail-modal", {
        ref: "complete",
        attrs: {
          type: "config",
          email: _vm.email,
          system: _vm.system,
          file: _vm.files.license
        },
        on: { accept: _vm.redirectToCreditOverview }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a0835f5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a0835f5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/IssueSystemConfig.vue
// module id = 772
// module chunks = 0